package domain.usecase

import domain.model.ActionCard
import domain.repository.ActionRepository

class ManageActionsUseCase(
    private val repository: ActionRepository
) {
    fun getActions(): List<ActionCard> {
        return repository.getActions()
    }
    
    fun addAction(action: ActionCard) {
        repository.addAction(action)
    }
    
    fun saveActions(actions: List<ActionCard>) {
        repository.saveActions(actions)
    }
    
    fun removeAction(actionId: String) {
        repository.removeAction(actionId)
    }
}
